// -----------------------------------------------

export default function Table(theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          // borderBottom: 'none',
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.grey[200],
          borderBottom: 'none',

          '&:first-of-type': {
            // borderTopLeftRadius: theme.shape.borderRadius,
            // borderBottomLeftRadius: theme.shape.borderRadius,
            // boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
          },
          '&:last-of-type': {
            // borderTopRightRadius: theme.shape.borderRadius,
            // borderBottomRightRadius: theme.shape.borderRadius,
            // boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
          },



          '&.rounded-top': {
            '&:first-of-type': {
              borderTopLeftRadius: theme.shape.borderRadius,
            },
            '&:last-of-type': {
              borderTopRightRadius: theme.shape.borderRadius,
            },
          },

          '&.rounded-bottom': {
            '&:first-of-type': {
              borderBottomRightRadius: theme.shape.borderRadius,
            },
            '&:last-of-type': {
              borderBottomRightRadius: theme.shape.borderRadius,
            },
          },


          // add gap on right and left
          '&.gap-head': {

            '&:first-of-type': {
              paddingLeft: theme.spacing(3),
              // boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
            },
            '&:last-of-type': {
              paddingRight: theme.spacing(3),
              // boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`
            },
          },

        },
        stickyHeader: {
          backgroundColor: theme.palette.grey[200],
        },
        body: {
          borderBottom: `solid 1px ${theme.palette.divider}`,
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          // borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
